<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? `Editing: ${item.name}` : 'Create New Material'" subtitle="Provide the main details of the Material in this section." class="py-8 border-b">
                <ui-input label="Name" name="name" :error="form.errors.get('name')" v-model="form.name"></ui-input>
                <ui-input-file preview :current="editMode ? item.image : null" label="Image" name="image" :error="form.errors.get('image')" v-model="form.image"></ui-input-file>
                <ui-select-searchable
                    class="xl:col-span-6"
                    label="Manufacturer"
                    v-model="form.manufacturer_id"
                    :error="form.errors.get('manufacturer_id')"
                    :search="searchManufacturers"
                ></ui-select-searchable>
                <ui-select-searchable
                    class="xl:col-span-6"
                    label="Category"
                    v-model="form.categories"
                    :error="form.errors.get('categories')"
                    :options="categories"
                    multiple
                ></ui-select-searchable>
                <ui-input label="Unit Of Measure" name="unit_of_measure" :error="form.errors.get('unit_of_measure')" v-model="form.unit_of_measure"></ui-input>
                <ui-input label="Form / Size / Shape" name="shape" :error="form.errors.get('shape')" v-model="form.shape"></ui-input>
                <ui-input label="Weight (KG)" name="weight" :error="form.errors.get('weight')" v-model="form.weight"></ui-input>
                <ui-textarea autoresize label="Additional Information" name="description" :error="form.errors.get('description')" v-model="form.description" placeholder="Useful information visible when viewing item"></ui-textarea>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Buying and selling" subtitle="Configure the buying, selling and stock control options." class="py-8 border-b">
                <ui-toggle label="We Purchase" text="Whether or not we purchase this material." name="purchasable" :error="form.errors.get('purchasable')" v-model="form.purchasable"></ui-toggle>
                <ui-toggle label="We Sell" text="Whether or not we sell this material." name="sellable" :error="form.errors.get('sellable')" v-model="form.sellable"></ui-toggle>
                <template v-if="form.sellable">
                    <ui-textarea autoresize label="Sale Description" name="sale_description" :error="form.errors.get('sale_description')" v-model="form.sale_description" placeholder="Description used on Quotes, Sales Orders & Sales Invoices"></ui-textarea>
                    <ui-input class="xl:col-span-6" label="Quantity Of Sale" name="quantity_of_sale" :error="form.errors.get('quantity_of_sale')" v-model="form.quantity_of_sale"></ui-input>
                    <ui-input class="xl:col-span-6" label="Sale Cost" name="sale_cost" :error="form.errors.get('sale_cost')" v-model="form.sale_cost"></ui-input>
                </template>
                <ui-toggle label="Stock Control" text="Whether or not we stock this material." name="stock_control" :error="form.errors.get('stock_control')" v-model="form.stock_control"></ui-toggle>
                <template v-if="form.stock_control">
                    <ui-input class="xl:col-span-6" label="SKU" name="sku" :error="form.errors.get('sku')" v-model="form.sku"></ui-input>
                    <ui-input class="xl:col-span-6" label="Amount In Stock" name="stock" :error="form.errors.get('stock')" v-model="form.stock"></ui-input>
                </template>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { Material, Company } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
        categories: Array,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : { sellable: true, purchasable: true, stock_control: true }

        return {
            form: new Form(initialData, async (form) => {
                try {
                    if (this.editMode) {
                        await this.item.update(form.export())
                        this.edit(false)
                    } else {
                        const material = await Material.create(form.export())
                        this.addItem(material, 0)

                        form.reset()
                    }
                } catch (error) {

                    throw error
                }
            }),
        }
    },
    methods: {
        async searchManufacturers (query) {
            return (await Company.search(query)).map(x => x.toDropdown())
        },
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
